export default "__VITE_ASSET__2dDCjkey__"